import { useCallback, useState } from 'react'

const useControls = () => {
  const [isPaused, setPause] = useState(false)
  const handlePause = useCallback(() => {
    setPause((paused) => !paused)
  }, [])

  const [isMuted, setMute] = useState(false)
  const handleMute = useCallback(() => setMute((muted) => !muted), [])

  return { isPaused, isMuted, handlePause, handleMute }
}

export default useControls
